export default __webpack_public_path__ + "static/media/network-status-60.e06c9867.png";